import React from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import HeaderContainer from 'containers/common/Header';
import Footer from './Footer';
import TopContainer from 'containers/top';
import StoryContainer from 'containers/story';
import CdContainer from 'containers/cd';
import CdDramaContainer from 'containers/cd/Drama';
import CdSituationContainer from 'containers/cd/Situation';
import GoodsContainer from 'containers/goods';

class Contents extends React.Component {
  render() {
    return (
      <div>
        <HeaderContainer />
        <Switch>
          <Route
            exact
            path='/'
            component={TopContainer}
          />
          <Route
            exact
            path='/story'
            component={StoryContainer}
          />
          <Route
            exact
            path='/cd'
            component={CdContainer}
          />
          <Route
            exact
            path='/cd/drama/:id'
            component={CdDramaContainer}
          />
          <Route
            exact
            path='/cd/situation/:id'
            component={CdSituationContainer}
          />
          <Route
            exact
            path='/goods'
            component={GoodsContainer}
          />
        </Switch>
        <Footer />
      </div>
    );
  }
}

export default withRouter(Contents)



// WEBPACK FOOTER //
// src/components/common/Contents.js